:host {
    display: block;
    height: 0;
    overflow: hidden;
    position: relative;
    z-index: 1;
}

:host([active]) {
    animation: open 500ms forwards;
}

::slotted(sew-ws-image-text),
::slotted(sew-ws-table) {
    margin: 60px 0;
}
::slotted(sew-ws-richtext),
::slotted(sew-ws-linklist),
::slotted(sew-ws-teaser) {
    margin: 40px 0;
}

::slotted(sew-ws-richtext) {
    width: 66%;
}

@include mq-2 {
    ::slotted(sew-ws-image-text),
    ::slotted(sew-ws-table) {
        margin: 40px 0;
    }
    ::slotted(sew-ws-richtext),
    ::slotted(sew-ws-linklist),
    ::slotted(sew-ws-teaser) {
        margin: 32px 0;
        width: auto;
    }
}

@keyframes open {
    from {
        opacity: 0;
        height: var(--tab-item-height);
    }

    to {
        overflow: visible;
        height: auto;
        opacity: 1;
    }
}

.print-headline {
    display: none;
}

@media print {
    .print-headline {
        @include typo-ws-h4;

        display: block;
        border-bottom: 5px solid $color-grey-01-dark;
        padding-bottom: 12px;
        margin: 0;
        page-break-after: avoid;
    }

    :host {
        height: auto;
    }
}
